import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import {
  AdministrationRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Dispatch, SetStateAction } from 'react';
import { getApiPortalLink, UserKeys } from '../../../api/users-api';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
interface ApiGridToolbarProps {
  administrationRoles: string[];
  setOpenCreateApiApp: Dispatch<SetStateAction<boolean>>;
  setOpenDeleteApiApp: Dispatch<SetStateAction<boolean>>;
  selectedRows: string[];
}

export default function ApiGridToolbar({
  administrationRoles,
  setOpenCreateApiApp,
  setOpenDeleteApiApp,
  selectedRows,
}: ApiGridToolbarProps) {
  const queryClient = useQueryClient();

  const { data: link } = useQuery({
    queryKey: [UserKeys.ApigeePortalLink],
    queryFn: () => getApiPortalLink(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
  });

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          variant="contained"
          disabled={
            !isAbleToSeeUIElement(
              administrationRoles,
              AdministrationRoles.CreateApiKeys.value
            )
          }
          onClick={() => setOpenCreateApiApp(true)}
          label="Add App"
          tooltipLabel={
            !isAbleToSeeUIElement(
              administrationRoles,
              AdministrationRoles.CreateApiKeys.value
            )
              ? `You are missing the ${AdministrationRoles.CreateApiKeys.name} permission to perform this action.`
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <Tooltip arrow title="API Portal">
            <IconButton
              component="a"
              href={link || ''}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkOutlined />
            </IconButton>
          </Tooltip>
          <SharedIconButton
            variant="delete"
            onClick={() => setOpenDeleteApiApp(true)}
            disabled={
              selectedRows?.length == 0 ||
              !isAbleToSeeUIElement(
                administrationRoles,
                AdministrationRoles.DeleteApiKeys.value
              )
            }
            tooltipLabel={
              selectedRows?.length === 0
                ? 'Select at least one row to delete'
                : !isAbleToSeeUIElement(
                    administrationRoles,
                    AdministrationRoles.DeleteApiKeys.value
                  )
                ? `You are missing the ${AdministrationRoles.DeleteApiKeys.name} permission to perform this action.`
                : 'Delete'
            }
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.ApigeeApps],
              });
            }}
            tooltipLabel="Refresh"
          />

          <SharedGridStateIconButton
            gridStateKey="apisGridStates"
            module="administration"
            section="api"
          />
        </>
      }
    />
  );
}
